"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setBlockedDomainsOption_1 = require("../actions/setBlockedDomainsOption");
var store_1 = require("../store/store");
var owa_junkmail_configuration_1 = require("owa-junkmail-configuration");
var owa_options_core_1 = require("owa-options-core");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_mail_option_common_1 = require("owa-mail-option-common");
var owa_options_controls_1 = require("owa-options-controls");
var BlockedDomainsFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedDomainsFull, _super);
    function BlockedDomainsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedDomains = function (blockedDomains) {
            setBlockedDomainsOption_1.default(blockedDomains);
        };
        return _this;
    }
    BlockedDomainsFull.prototype.render = function () {
        var domains = owa_options_core_1.getFallbackValueIfNull(this.props.optionState.blockedDomains, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !owa_mail_option_common_1.isEmailAddress(item); }));
        return (React.createElement("div", null, domains && (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_junkEmail_blockedDomains),
            React.createElement(owa_mail_option_common_1.EditSendersAndDomains, { items: domains, onItemsChanged: this.onChangeBlockedDomains, mode: 1 /* DomainOnly */ })))));
    };
    BlockedDomainsFull = tslib_1.__decorate([
        react_1.reactive({
            optionState: function () { return store_1.default; },
            junkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedDomainsFull);
    return BlockedDomainsFull;
}(React.Component));
exports.default = BlockedDomainsFull;
//# sourceMappingURL=BlockedDomainsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-domains-option/lib/components/BlockedDomainsFull.js
// module id = 5030
// module chunks = 2